import { useState } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { useAbortedEffect } from "../../../components/hooks";
import { KnowledgeAPI } from "../../../axios/api";
import { sortableContainer, sortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";

import { Button } from "primereact/button";

export default function ModulePopKnowledgeOrder({
  prePopOption,
  closePrePop,
  setPreReload,
}) {
  const dispatch = useDispatch();
  const [sortData, setSortData] = useState([]);

  useAbortedEffect((signal) => {
    dispatch(setProgress(true));

    let params = {
      page: -1,
      type: prePopOption.data.type,
    };

    KnowledgeAPI.getKnowledgesDataByType({
      data: params,
      options: { signal },
    }).then((result) => {
      let { Response, data, message } = result;

      if (Response === 1) {
        setSortData(data);
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
      }

      dispatch(setProgress(false));
    });
  }, []);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setSortData(arrayMove(sortData, oldIndex, newIndex));
  };

  const saveData = () => {
    dispatch(setProgress(true));

    let jsonData = {
      data: sortData.map((item, index) => ({
        id: item.id,
        orders: index + 1,
      })),
    };

    KnowledgeAPI.updateKnowledgesOrders({
      data: jsonData,
    }).then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        setPreReload((state) => ({ ...state, list: true }));
        closePrePop({ type: prePopOption.type });
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <div className="px-3">
        <SortableContainer onSortEnd={onSortEnd}>
          {sortData.map((item, index) => (
            <SortableItem
              key={`item-${index}`}
              index={index}
              sortIndex={index}
              value={item.title}
            />
          ))}
        </SortableContainer>

        <div className="flex mt-3">
          <Button
            type="button"
            label="取消"
            className="p-button-secondary p-button-outlined ml-auto px-3"
            onClick={() => closePrePop({ type: prePopOption.type })}
          />
          <Button
            type="button"
            label="儲存"
            className="ml-2 px-3"
            onClick={() => saveData()}
          />
        </div>
      </div>
    </>
  );
}

const SortableContainer = sortableContainer(({ children }) => {
  return <div className="sort-wrap">{children}</div>;
});

const SortableItem = sortableElement(({ value }) => {
  return <div className="sort-item">{value}</div>;
});
